import { createContext } from '@lit/context'

export type TSchmancyTabsMode = 'scroll' | 'tabs'

export const SchmancyTabsModeContext = createContext<TSchmancyTabsMode>('tabs')

/**
 * Whether an inactive panel keeps its box instead of emptying out. Provided by
 * the group so a panel added to an already-mounted group picks it up on
 * connect, rather than only at the group's next slotchange.
 */
export const SchmancyTabsKeepMountedContext = createContext<boolean>('tabs-keep-mounted')
